import { Flex, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
import TableViewButton from '@components/button/TableViewButton.'
import TableEditButton from '@components/button/TableEditButton'
import TableDeleteButton from '@components/button/TableDeleteButton'
import TablePagination from '@components/table/template/TablePagination'
import TableTemplate from '@components/table/template/TableTemplate'
import { ITHeadMap } from '@interfaces/ITable'
import InputCheckOwner from '@components/form/input/InputCheckOwner'
import { Link } from 'react-router-dom'
import TableAddNewButton from '@components/button/TableAddNewButton'
import { modals } from '@mantine/modals'
import { QueryObserverResult } from 'react-query'
import InputStatus from '@components/form/input/InputStatus'
import {
    IResponseGetAllVendorTypes,
    IResponseGetAllVendorTypesRowData,
} from '@interfaces/api/IVendor'
import Vendor from '@api/Vendor'
import TableSearchFilter from '@components/table/filter/TableSearchFilter'

const TableAllVendorType = () => {
    const [limit, setlimit] = useState(10)
    const [orderby, setorderby] =
        useState<keyof IResponseGetAllVendorTypesRowData>('vendor_type_id')
    const [order, setorder] = useState('desc')
    const [page, setpage] = useState(1)
    const [search, setsearch] = useState('')
    const [checkowner, setcheckowner] = useState(0)
    const [status, setstatus] = useState('')

    const lists = Vendor.useGetAllVendorTypes({
        limit,
        orderby,
        order,
        page,
        search,
        checkowner,
        status,
    })

    useEffect(() => {
        lists.refetch()
        // eslint-disable-next-line
    }, [page, status, limit, order, orderby, checkowner])

    const thead: ITHeadMap<IResponseGetAllVendorTypesRowData>[] = [
        {
            sortkey: 'vendor_type_name',
            label: 'ชื่อประเภทผู้ค้า',
            width: '30%',
        },
        {
            sortkey: 'status',
            label: 'สถานะ',
            width: '30%',
        },
        // {
        //     sortkey: 'created_at',
        //     label: 'สร้างเมื่อ',
        //     width: '11%',
        // },
        // {
        //     sortkey: 'updated_at',
        //     label: 'แก้ไขล่าสุด',
        //     width: '11%',
        // },
        {
            label: 'Action',
            width: '10%',
        },
    ]

    return (
        <>
            <Flex gap='md' direction={{ xs: 'column', lg: 'row' }}>
                <TableSearchFilter
                    page={page}
                    setpage={setpage}
                    setsearch={setsearch}
                    search={search}
                    refresh={lists.refetch}
                />
                <InputCheckOwner
                    miw='180px'
                    w='100%'
                    value={String(checkowner)}
                    onChange={(value) => {
                        if (value !== String(checkowner)) {
                            setcheckowner(Number(value))
                            setpage(1)
                        }
                    }}
                />
                <InputStatus
                    withAll
                    miw='180px'
                    value={String(status)}
                    onChange={(value) => {
                        if (value !== status) {
                            setstatus(String(value))
                            setpage(1)
                        }
                    }}
                />

                <TableAddNewButton
                    component={Link}
                    to='/vendors/types/create'
                    label='เพิ่มประเภทผู้ค้า'
                />
            </Flex>

            <TableTemplate<IResponseGetAllVendorTypesRowData>
                thead={thead}
                orderby={orderby}
                order={order}
                setorder={setorder}
                setorderby={setorderby}
                lists={lists?.data?.lists}
            >
                {lists?.data?.lists.map((value) => (
                    <AllProjectTableRow
                        key={value.vendor_type_id}
                        data={value}
                        refreshTable={lists.refetch}
                    />
                ))}
            </TableTemplate>
            {lists.data?.lists.length ? (
                <TablePagination
                    limit={lists.data?.lists.length}
                    setlimit={setlimit}
                    setpage={setpage}
                    page={page}
                    totalPages={lists.data.totalPages}
                    totalRows={lists.data.totalRows}
                />
            ) : (
                <></>
            )}
        </>
    )
}

export default TableAllVendorType

const AllProjectTableRow = ({
    data,
    refreshTable,
}: {
    data: IResponseGetAllVendorTypesRowData
    refreshTable: () => Promise<
        QueryObserverResult<IResponseGetAllVendorTypes, unknown>
    >
}) => {
    const Delete = Vendor.useDeleteVendorType({
        vendor_type_id: data.vendor_type_id,
        aftersuccess: refreshTable,
    })

    const openDeleteConfirmModal = () =>
        modals.openConfirmModal({
            title: 'กรุณายืนยันการลบ',
            children: (
                <Text>
                    ลบประเภทผู้ค้า <br />
                    {data.vendor_type_name}
                </Text>
            ),
            labels: { confirm: 'ยืนยัน', cancel: 'ยกเลิก' },
            onConfirm: Delete.onSubmit,
        })

    return (
        <tr key={data.vendor_type_id}>
            <td>{data.vendor_type_name}</td>
            <td>{data.status_description}</td>
            {/* <DateAndFullNameColumn
                day={data.created_at}
                fullname={data.created_by_user_fullname}
                user_id={data.created_by_user_id}
            />
            <DateAndFullNameColumn
                day={data.updated_at}
                fullname={data.updated_by_user_fullname}
                user_id={data.updated_by_user_id}
            /> */}
            <td>
                <Flex gap='xs' pos='relative'>
                    <TableViewButton
                        component={Link}
                        to={`/vendors/types/${data.vendor_type_id}/view`}
                    />
                    <TableEditButton
                        component={Link}
                        to={`/vendors/types/${data.vendor_type_id}/edit`}
                    />
                    <TableDeleteButton onClick={openDeleteConfirmModal} />
                </Flex>
            </td>
        </tr>
    )
}
